import { Page } from "@roc/feature-app-core";
import { SendWire } from "@roc/feature-send-wire";
import { Route } from "react-router";
import { useRocInternalPortalStore } from "../../../hooks";

export const getSendWireInternalRoutesConfig =
(basePath: string, baseUrl: string) => {
  return {
    sendWire: {
      path: `${basePath}/send-wire/:drawId/:loanId`,
      url: `${baseUrl}/send-wire/:drawId/:loanId`,
      documentTitle: 'Send Draw Wire',
    },
  };
};
export const getSendWireInternalRoutes = (basePath: string, baseUrl: string) => {
  const config = getSendWireInternalRoutesConfig(basePath, baseUrl);
  const { sendWireInternalStore } = useRocInternalPortalStore();
  return {
    sendWire: (
      <Route exact path={config.sendWire.path}>
        <Page routeDefinition={config.sendWire}>
          <SendWire store={sendWireInternalStore}/>
        </Page>
      </Route>
    ),
  };
};